import { createAppSlice } from '../../app/createAppSlice'

const initialState = { toolName: "" };

const footerSlice = createAppSlice({
    name: "footer",
    initialState,
    reducers: create => ({
        changeTool: create.reducer((state, action) => {
            state.toolName = action.payload
        }),
        defaultToResourceViewer: create.reducer((state) => {
            if (!state.toolName) {
                state.toolName = "FEvIR®: Resource Viewer";
            }
        }),
    }),
    selectors: {
        selectToolName: footer => footer.toolName
    },
})

export const { changeTool, defaultToResourceViewer } = footerSlice.actions

export const { selectToolName } = footerSlice.selectors

export default footerSlice